import {until} from 'lit-html/directives/until';
import {rosterErrors, modals} from '../../../../modules/constants-enumerate';
import {rosterErrorLabels} from '../../../../modules/i18n-labels';
import '../../../../modules/show-modal';

export default (ctx, html) => html`
<p class="text-danger text-center">
  ${until(ctx.__('<tt-B9JOQ1n4>', 'Please correct the following column name in your CSV and reupload your updated CSV'))}
  <show-modal id="info-btn" class="btn rounded-pill" modal-id="${modals.CSV_COL_ERROR}" >${until(ctx.__('<tt-zP4ZO1v5>', '?'))}</show-modal>
</p>
<div class="row">
  ${ctx.errors.map((error) => html`
    ${error.type === rosterErrors.CSV_INVALID_PROPERTY? html`
    <div class="col-sm-6 col-md-4 mb-3">
      <div class="card card-border-color-left card-border-color-warning">
      <div class="card-header">${until(rosterErrorLabels[error.type])}</div>
        <div class="card-body">
          <div class="font-weight-bold">${until(ctx.__('<tt-g4kllfTa>', 'Column'))} ${ctx.numberToExcelCol(error.payload.column)}, ${error.payload.property}</div>
        </div>
      </div>
    </div>
    `: ''}

    ${error.type === rosterErrors.INVALID_TIERS? html`
    <div class="col-sm-6 col-md-4 mb-3">
      <div class="card card-border-color-left card-border-color-warning">
        <div class="card-header">${until(rosterErrorLabels[error.type])}</div>
        <div class="card-body">
        <div class="font-weight-bold">${until(ctx.__('<tt-KX3QyX8s>', 'Your roster file does not match your template.  Please redownload your roster template and update your roster information into the correct template.'))}</div>
        </div>
      </div>
    </div>
    `: ''}
  `)}
  </div>`;
